import { render, staticRenderFns } from "./Followers.vue?vue&type=template&id=7bb33211&scoped=true&"
import script from "./Followers.vue?vue&type=script&lang=js&"
export * from "./Followers.vue?vue&type=script&lang=js&"
import style0 from "./Followers.vue?vue&type=style&index=0&id=7bb33211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb33211",
  null
  
)

export default component.exports